module.exports = __webpack_public_path__ + "static/media/S (140).1fc42d91.jpg";